window.loadScript = (function() {
  var loadedScripts = new Map();
  return function (url, type, callback) {
    if (loadedScripts.has(url) && loadedScripts.get(url)) return callback();
    loadedScripts.set(url, false);
    var script = document.querySelector(`script[src="${url}"]`);
    if (!script) {
      script = document.createElement('script');
      script.type = type || 'text/javascript';
      script.src = url;
      addLoadFunctions();
      document.getElementsByTagName('head')[0].appendChild(script);
      return;
    }
  
    return addLoadFunctions();
  
    function addLoadFunctions() {
      function handleLoad() {
        loadedScripts.set(url, true);
        script.removeEventListener('load', handleLoad);
        if (typeof callback === 'undefined') return;
        callback();
      }
      script.addEventListener('load', handleLoad);
    }
  };
})()